module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAARdJREFUWEft11EOgyAMBmC4yLLb1bfpScbe5HbLLsKCkQQZSqFlMVt9Bvz82wBqdfJHn9ynBEitkCT4fwlaax31qynzAWDTdh89KMBCvJgEL5QSUecCwCteQ7YZaqKSoCSITcBae1dKjet4AwATdu7ROJYeTHDhfSxIMnAHx4YkAVOcc+7hZVrrW1Q2UpLNwBxuGIalB+d5NlzIJuARLiTHhawGYnCcyCpgDY4LiQa24DiQKCAFR0UWgRw4CvIQyIlrRe4Ce+BakFlgT1wtMvdXF99KlD++wgnBcTuJ18Bs5hvgN5JLP7KETIH+LPUJdk2ugJwAwIQxuRKPzrlrr7Lutcma5DPGLTcj7r7iXk+A1EQlwZ9P8A016N0pOkN62QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/home/top.png
// module id = eJJP
// module chunks = 101